import React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'
import { Link } from 'gatsby'

const LogoContainer = styled.div`
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 6rem;
  grid-area: logo;
  a {
    height: 3rem;
    background: transparent;
    border: none;
    box-shadow: none;
    :hover {
      background: transparent;
    }
    svg {
      will-change: transform;
    }
  }
`

const Logo = ({ logoBig }) => {
  const logoAnimation = useSpring({
    transform: logoBig
      ? 'translate3d(0, -28px, 0) scale(2)'
      : 'translate3d(0, 0, 0) scale(1)',
    // height: logoBig ? '5.8rem' : '2.9rem',
    config: { mass: 1, tension: 210, friction: 20, velocity: 20 },
  })

  return (
    <LogoContainer>
      <Link to="/">
        <animated.svg
          id="svg4731"
          version="1.1"
          viewBox="0 0 132.29178 38.641926"
          xmlns="http://www.w3.org/2000/svg"
          height="50"
          style={logoAnimation}
        >
          <defs id="defs4725" />
          <g
            id="layer1"
            style={{ display: 'inline' }}
            transform="translate(-25.77364,-157.84495)"
          >
            <g id="g6418" />
            <g id="g6531">
              <g
                id="flowRoot4294"
                style={{
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  lineHeight: '0.01%',
                  fontFamily: 'sans-serif',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.7507655',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                transform="matrix(0.44976074,0,0,0.44976074,-78.453667,19.157608)"
              />
              <g
                id="g6762"
                style={{ display: 'inline' }}
                transform="translate(25.907275,201.00898)"
              />
              <g
                id="flowRoot4286"
                style={{
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  lineHeight: '0.01%',
                  fontFamily: 'sans-serif',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.85086757',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                transform="matrix(0.44976074,0,0,0.44976074,-78.453667,19.157608)"
              >
                <path
                  id="path6187"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 347.17931,354.63923 q 0,1.01069 -0.39304,1.01069 -0.39305,0 -0.72995,-0.67379 -0.28075,-0.6738 -0.39305,-1.29144 -0.0562,-0.61765 -0.0562,-1.0107 -1.34759,-0.61764 -2.86363,-1.62834 -1.51604,-1.01069 -1.51604,-1.90908 0,-0.3369 0.28075,-0.3369 0.16845,0 1.0107,0.5615 0.84224,0.50534 1.79678,1.17914 1.0107,0.61764 1.29144,0.72994 0,-6.17645 3.42513,-16.50798 3.48128,-10.33153 7.18715,-17.91172 -6.7941,-1.62834 -11.56682,-1.62834 -2.35828,0 -4.49197,0.44919 -2.13368,0.39305 -4.09892,1.34759 -1.96523,0.8984 -3.14438,2.75134 -1.17914,1.85293 -1.17914,4.37966 0,5.72726 5.44651,10.78073 0.2246,-1.12299 0.5615,-1.12299 0.39305,0 0.95454,1.23529 0.61765,1.17914 0.61765,1.62834 0,0.72994 -1.01069,0.72994 -2.07754,0 -4.21122,-2.35828 -2.07754,-2.41444 -3.31283,-5.39036 -1.17914,-2.97593 -1.17914,-5.05347 0,-3.08823 1.34759,-5.27806 1.40374,-2.24599 3.76202,-3.36898 2.35828,-1.12299 4.88502,-1.62834 2.52673,-0.50534 5.39036,-0.50534 5.16576,0 11.95986,1.45989 0.7861,-1.85294 1.68449,-2.63903 0.0562,0 0.1123,0 0.2246,0 0.50535,-0.0561 0.28075,-0.0562 0.61764,-0.1123 0.3369,-0.1123 0.5615,-0.1123 1.57219,0 1.57219,0.67379 0,0.0562 -0.0562,0.1123 0,0.0562 0,0.1123 -0.61765,0.84224 -1.62834,2.75133 2.07754,0.5615 4.21122,1.40374 2.13369,0.7861 4.54812,2.07754 2.41443,1.29144 3.87432,3.14437 1.51604,1.85294 1.51604,3.98663 0,1.96523 -1.29144,3.64972 -1.23529,1.62834 -3.36898,2.80748 -2.07753,1.12299 -3.93047,1.85294 -1.79679,0.72994 -3.76202,1.23529 2.02138,0.1123 4.37967,0.61765 2.35828,0.50534 4.88501,1.45989 2.52673,0.95454 4.15507,2.69518 1.68449,1.74063 1.68449,3.93047 0,2.13368 -1.96523,4.21122 -5.67111,5.95186 -16.11494,5.95186 -6.9064,0 -12.01602,-1.85294 0,0.2246 0,0.6738 0.0562,0.50534 0.0562,0.78609 z m 24.64968,-27.90635 q 0,-1.74064 -1.34759,-3.31283 -1.34759,-1.62834 -3.53743,-2.75133 -2.13368,-1.12299 -3.93047,-1.85294 -1.79679,-0.72994 -3.53742,-1.23529 h -0.0562 q -4.54812,7.91709 -8.08555,18.75397 0.8984,-0.28075 2.47059,-0.39305 1.62833,-0.16845 2.13368,-0.28075 2.02139,-0.33689 4.21122,-0.89839 2.24599,-0.61765 5.10962,-1.68449 2.91978,-1.06684 4.71656,-2.69518 1.85294,-1.68449 1.85294,-3.64972 z m 0.39305,23.24593 q 2.35828,-2.35828 2.35828,-4.60427 0,-2.24598 -1.85294,-3.87432 -1.79678,-1.68449 -4.60426,-2.47058 -2.75134,-0.78609 -5.22192,-1.12299 -2.47058,-0.39305 -4.49197,-0.39305 -0.61764,0 -2.35828,0.2246 -1.74064,0.16845 -3.36898,0.3369 -1.57218,0.16845 -1.90908,0.16845 -0.0562,0 -0.0562,0 -2.86363,8.87163 -3.48128,13.5882 4.82887,1.90909 11.95987,1.90909 9.32083,0 13.02671,-3.76203 z"
                />
                <path
                  id="path6189"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 397.90346,329.65266 q -0.16845,0.50534 -1.23529,3.36897 -1.06684,2.86363 -1.74064,4.82887 -1.01069,2.86363 -2.18983,6.96255 -1.12299,4.09892 -1.12299,4.99731 0,0.16845 0.1123,0.16845 0.44919,0 2.24598,-1.40374 1.85294,-1.40374 2.52673,-1.40374 0.4492,0 0.4492,0.28075 0,0.39305 -1.29144,1.29144 -1.23529,0.89839 -2.86363,1.90909 -1.62834,0.95454 -1.79679,1.06684 -0.39305,0.3369 -1.17914,1.12299 -0.72995,0.84225 -1.40374,1.34759 -0.61765,0.5615 -1.12299,0.5615 -0.72995,0 -0.72995,-0.61765 0,-0.39304 0.8984,-1.23529 0.89839,-0.78609 1.17914,-1.40374 0.95454,-2.30213 3.81817,-13.41975 -2.63903,3.93047 -7.0187,8.81548 -4.32352,4.82887 -6.51335,4.82887 -0.7861,0 -0.7861,-1.01069 0,-0.84225 0.61765,-2.41444 0,-0.0562 1.34759,-3.03207 1.34759,-2.97593 2.13368,-5.10962 0.84225,-2.18983 0.84225,-3.14438 0,-0.28074 -0.1123,-0.50534 -0.1123,-0.28075 -0.1123,-0.4492 0,-0.0562 0.1123,-0.61765 0.95454,-3.59357 1.79678,-4.71656 0.84225,-1.17914 2.80749,-1.17914 0.78609,0 0.95454,0.50534 -6.73795,16.56414 -6.73795,17.35023 0,0.2246 0.16844,0.2246 0.2246,0 1.3476,-0.89839 5.61496,-4.32352 9.88233,-12.12832 0.0562,-1.74064 1.06684,-3.59357 1.01069,-1.85294 2.97593,-1.85294 0.61764,0 0.67379,0.50535 z"
                />
                <path
                  id="path6191"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 412.61378,331.95479 q -0.1123,1.12299 -1.45989,3.20053 -1.34759,2.07753 -2.07754,2.07753 -0.2246,0 -0.2246,-0.3369 0,-0.50534 0.61765,-2.02138 0.61764,-1.57219 0.61764,-2.02139 0,-0.84224 -1.01069,-0.84224 -0.16845,0 -1.85294,0.28075 -1.40374,0.33689 -3.70587,1.79678 -2.24598,1.45989 -2.24598,3.20053 0,0.61765 0.28074,1.12299 0.72995,1.45989 2.52674,2.47059 1.85293,1.01069 3.14437,1.90908 1.3476,0.8984 1.3476,2.35829 0,2.47058 -3.81818,4.77271 -3.76202,2.24599 -6.4572,2.24599 -0.4492,0 -0.72995,-0.39305 -0.28075,-0.3369 -0.28075,-0.72995 0,-0.67379 0.61765,-0.67379 1.85294,0 5.16576,-1.12299 3.36898,-1.17914 3.36898,-2.52673 0,-0.7861 -1.29144,-1.85294 -1.23529,-1.06684 -2.75133,-1.96524 -1.45989,-0.89839 -2.75133,-2.13368 -1.23529,-1.29144 -1.23529,-2.47059 0,-0.95454 0.67379,-1.79678 0.50535,-0.61765 1.06684,-1.17914 0.5615,-0.61765 1.06685,-1.06685 0.50534,-0.44919 1.12299,-0.89839 0.67379,-0.4492 1.17914,-0.7861 0.50535,-0.33689 1.17914,-0.67379 0.6738,-0.3369 1.06685,-0.50535 0.39304,-0.2246 1.01069,-0.50534 0.67379,-0.28075 0.89839,-0.3369 0.28075,-0.1123 0.84225,-0.3369 0.56149,-0.2246 0.61764,-0.2246 0.95454,-0.28074 1.45989,-0.28074 2.02139,0 2.02139,2.24598 z"
                />
                <path
                  id="path6193"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 429.50955,331.33714 q -3.03208,4.88502 -5.67111,10.89303 -2.58289,5.95186 -2.58289,9.26468 0,0.7861 0.4492,0.7861 0.16845,0 0.95454,-0.50535 0.84225,-0.50535 1.0107,-0.50535 0.28074,0 0.28074,0.3369 0,0.6738 -1.06684,1.40374 -1.06684,0.7861 -2.07753,0.7861 -1.40374,0 -1.40374,-2.07754 0,-2.41443 1.57219,-6.7941 1.57218,-4.43582 3.14437,-8.0294 1.57219,-3.64972 1.57219,-4.09892 0,-0.1123 -0.0562,-0.1123 -0.2246,0 -1.01069,0.84225 -3.53743,3.98662 -5.95186,7.80479 -2.41443,3.76203 -3.25668,5.78341 -0.78609,2.02139 -1.68448,3.25668 -0.84225,1.17914 -2.02139,1.17914 -0.50535,0 -0.50535,-0.56149 0,-0.50535 0.28075,-1.123 1.51604,-3.93047 2.91978,-8.14169 1.40374,-4.21122 2.97593,-9.37698 1.62834,-5.22192 2.63903,-8.254 0.16845,-0.50534 0.16845,-1.01069 0,-0.2246 -0.0562,-0.39305 -0.0562,-0.22459 -0.0562,-0.33689 0,-0.2246 0.16845,-0.72995 1.29144,-3.59357 2.18983,-4.71656 0.8984,-1.17915 2.75134,-1.17915 0.72994,0 0.84224,0.50535 -6.12031,12.35291 -9.93848,26.27801 8.36629,-13.08285 12.63366,-13.08285 1.17914,0 1.17914,0.78609 0,0.50535 -0.39304,1.12299 z"
                />
                <path
                  id="path6195"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 430.3825,350.59646 q -0.28075,0.67379 -0.5615,0.67379 -0.50534,0 -1.12299,-0.67379 -0.61764,-0.6738 -0.61764,-1.57219 0,-0.84224 1.34759,-4.26737 0.16845,-0.4492 0.50534,-0.6738 0.39305,-0.22459 0.4492,-0.39304 6.06416,-15.77804 9.60158,-27.90636 l 0.4492,-0.33689 q 0.39305,-0.3369 0.95454,-0.6738 0.61765,-0.3369 1.0107,-0.3369 0.56149,0 0.56149,0.84225 -0.61764,2.30213 -3.93047,11.28607 -3.31283,8.98393 -5.44651,14.1497 2.13368,-3.20053 5.61496,-7.131 3.53742,-3.98662 5.27806,-3.98662 1.12299,0 1.12299,2.07753 v 0.39305 q -0.0562,1.12299 -1.06684,5.05346 1.23529,-0.61764 1.68449,-0.61764 0.16845,0 0.16845,0.1123 0,0.28074 -0.72995,0.84224 -0.67379,0.5615 -1.40374,0.84224 -2.18983,7.2433 -4.26737,9.54544 -0.78609,0.84224 -3.20053,2.35828 -2.41443,1.45989 -2.97592,1.45989 -2.30214,0 -3.42513,-1.06684 z m 11.06147,-10.94917 q -6.62565,3.48127 -8.53474,5.55881 -0.3369,0.67379 -0.84224,1.74063 -0.4492,1.06685 -0.61765,1.40374 1.34759,1.51604 2.75133,1.51604 2.30214,0 4.26737,-3.42512 2.02139,-3.42513 2.97593,-6.7941 z m 0.4492,-1.2353 q 0.89839,-2.35828 1.01069,-4.88501 0,-1.17914 -0.56149,-1.17914 -1.85294,0 -9.04009,11.45452 3.36898,-2.75133 8.59089,-5.39037 z"
                />
                <path
                  id="path6197"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 459.74699,316.2329 q -3.08823,6.40105 -6.28876,15.49729 -3.20052,9.04009 -4.71656,15.83419 -0.0562,0.16845 -0.0562,0.4492 0,0.67379 0.56149,0.67379 0.3369,0 1.79679,-0.84224 1.51604,-0.84225 1.90909,-0.84225 0.3369,0 0.50534,0.2246 0,0.6738 -2.80748,2.52673 -2.80748,1.79679 -3.98662,1.79679 -1.06684,0 -1.06684,-1.01069 0,-0.5615 0.2246,-1.17914 1.45989,-3.98663 2.69518,-7.9171 1.29144,-3.93047 2.91978,-9.32083 1.62834,-5.44651 2.41443,-8.0294 0.16845,-0.50534 0.16845,-1.01069 0,-0.2246 -0.1123,-0.39305 -0.0562,-0.22459 -0.0562,-0.39304 0,-0.16845 0.16845,-0.6738 1.12299,-3.53742 2.07754,-4.71656 0.95454,-1.17915 2.80748,-1.17915 0.78609,0 0.84224,0.50535 z"
                />
                <path
                  id="path6199"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 473.37379,346.72214 q -0.0562,0.0561 -0.50534,0.50534 -0.4492,0.39305 -0.72995,0.61765 -0.28075,0.2246 -0.84224,0.72994 -0.50535,0.4492 -0.8984,0.72995 -0.39304,0.28075 -0.95454,0.67379 -0.5615,0.39305 -1.01069,0.61765 -0.39305,0.16845 -0.84225,0.3369 -0.44919,0.16844 -0.84224,0.16844 -1.17914,0 -1.40374,-1.40374 0,-2.35828 1.85294,-8.70318 -7.52405,10.38767 -10.78073,10.38767 -1.34759,0 -1.34759,-2.02138 0,-2.58289 1.51604,-6.96255 1.57219,-4.43582 3.81817,-7.97325 2.24599,-3.59357 3.93048,-3.59357 h 0.16845 l 0.61764,-0.4492 q 0.50535,-0.5615 1.57219,-0.5615 0.84224,0 2.35828,0.4492 1.51604,0.4492 1.68449,0.4492 0.2246,0 0.5615,-0.4492 0.39304,-0.4492 0.89839,-0.4492 1.40374,0 1.40374,1.2353 0,0.50534 -0.2246,1.12299 -0.16845,0.61764 -0.56149,1.45989 -0.3369,0.78609 -0.39305,0.95454 -0.0562,0.1123 -0.5615,0.3369 -0.44919,0.2246 -0.50534,0.39305 -1.23529,3.48127 -2.18984,7.46789 -0.95454,3.93048 -0.95454,4.82887 0,1.40374 0.78609,1.40374 0.7861,0 1.90909,-0.95454 1.17914,-0.95455 2.02139,-1.90909 0.84224,-0.95454 0.89839,-0.95454 0.1123,0 0.1123,0.22459 0,0.84225 -0.5615,1.29145 z m -3.70587,-14.9358 q -0.3369,0 -1.17914,-0.1123 -0.7861,-0.1123 -1.34759,-0.1123 -0.7861,0 -1.68449,0.2246 -1.40374,0.39305 -4.60427,6.6818 -3.20053,6.23261 -3.20053,9.32084 0,0.95454 0.5615,0.95454 1.17914,0 4.15507,-3.42512 3.03208,-3.42513 3.98662,-4.88502 1.40374,-2.24598 2.58288,-4.82887 1.17915,-2.63903 1.17915,-3.48127 0,-0.3369 -0.28075,-0.3369 z"
                />
                <path
                  id="path6201"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 497.07595,314.82916 q 0.16845,0.1123 0.16845,0.50535 0,0.89839 -0.89839,3.36897 -0.84225,2.41444 -2.41444,6.34491 -1.51604,3.87432 -2.35828,6.3449 0.0562,-0.0562 0.1123,-0.0562 0.2246,0 0.4492,0.39305 0.28074,0.39305 0.28074,0.72995 0,0.33689 -0.56149,0.33689 -0.72995,0 -0.7861,-0.16845 -1.12299,2.52674 -2.86363,8.19785 -1.68448,5.67111 -1.68448,6.96255 0,1.29144 0.72994,1.29144 0.84224,0 1.96524,-0.95454 1.12299,-1.0107 1.96523,-2.02139 0.8984,-1.01069 1.06685,-1.01069 0.16844,0 0.16844,0.28074 0,0.16845 -0.1123,0.4492 -0.0561,0.28075 -0.16844,0.50535 -0.0562,0.16845 -0.1123,0.16845 -1.29144,1.29144 -3.59358,2.97593 -2.30213,1.62833 -3.59357,1.62833 -1.06685,0 -1.06685,-1.17914 0,-3.03208 2.13369,-9.26468 -2.41443,3.42512 -5.89571,7.18715 -3.42512,3.76202 -5.39036,3.76202 -1.17914,0 -1.17914,-1.68449 0,-2.41443 1.68449,-6.96255 1.68448,-4.60427 3.98662,-8.31014 2.35828,-3.76202 3.93047,-3.76202 h 0.2246 q 0.39305,0 0.89839,-0.39305 0.5615,-0.4492 1.17914,-0.4492 0.84225,0 2.35829,0.4492 1.57219,0.4492 1.68449,0.4492 0.0561,0 0.0561,-0.0562 4.04278,-10.89303 4.15508,-11.22992 -0.61765,0 -0.61765,-0.6738 0,-1.57219 1.68449,-4.09892 0.2246,-0.4492 0.89839,-0.4492 0.72995,0 1.51604,0.39305 z m -8.02939,17.35023 q 0,-0.61765 -3.31283,-0.61765 -0.95454,0 -1.40374,0.1123 -1.23529,0.3369 -4.77272,6.7941 -3.48127,6.45721 -3.48127,9.43314 0,0.89839 0.56149,0.89839 0.5615,0 1.62834,-0.89839 1.06685,-0.8984 1.96524,-1.90909 0.89839,-1.01069 1.96524,-2.18983 1.06684,-1.2353 1.12299,-1.34759 1.51604,-1.68449 2.75133,-3.93048 1.29144,-2.30213 2.07753,-4.26737 0.84225,-1.96523 0.8984,-2.07753 z"
                />
                <path
                  id="path6203"
                  style={{
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontSize: '56.1496048px',
                    lineHeight: '125%',
                    fontFamily: "'Bilbo Swash Caps'",
                    InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                    textAlign: 'start',
                    writingMode: 'lr-tb',
                    textAnchor: 'start',
                    fill: '#333333',
                    fillOpacity: '1',
                    stroke: '#333333',
                    strokeWidth: '0.85086757',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 507.00566,333.75158 q 0.3369,1.74063 0.3369,2.80748 0,1.23529 -0.84225,2.13368 -0.84224,0.84225 -2.18983,1.23529 -1.34759,0.3369 -2.41444,0.50535 -1.06684,0.1123 -2.02138,0.1123 -0.5615,0 -1.29144,0 -0.6738,-0.0562 -0.72995,-0.0562 -1.85293,4.71657 -1.85293,7.41175 0,2.24598 1.68448,2.24598 1.17915,0 2.75133,-1.45989 1.57219,-1.51604 2.75133,-2.97593 1.17915,-1.51604 1.40374,-1.51604 0.39305,0 0.39305,0.4492 0,1.57219 -3.08823,4.37967 -3.08822,2.75133 -4.82886,2.75133 -1.40374,0 -2.58288,-0.84224 -1.123,-0.8984 -1.123,-2.91978 0,-0.61765 0.16845,-1.45989 0.39305,-2.13369 1.0107,-4.15507 0.67379,-2.02139 0.72994,-2.47059 -0.84224,-0.2246 -0.84224,-0.89839 0,-0.61765 0.95454,-0.61765 h 0.39305 q 2.24598,-4.43581 2.58288,-5.10961 1.57219,-2.97593 6.00801,-2.97593 1.90908,0 2.63903,3.42513 z m -2.02139,2.69518 q 0,-1.40374 -0.28075,-2.41444 -0.28074,-1.01069 -0.67379,-1.40374 -0.3369,-0.39304 -0.72995,-0.39304 -1.12299,0 -2.69518,2.41443 -1.51604,2.41443 -2.24598,4.26737 0.1123,0 0.89839,0.0562 0.7861,0.0561 1.34759,0.0561 2.30214,0 3.31283,-0.50535 1.01069,-0.50534 1.06684,-2.07753 z"
                />
              </g>
              <path
                id="path6206"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 70.407324,186.11786 q -0.644192,1.03787 -1.204877,2.31432 -0.548758,1.26453 -0.548758,1.96837 0,0.16701 0.09543,0.16701 0.0358,0 0.202801,-0.10737 0.178942,-0.10736 0.214734,-0.10736 0.05965,0 0.05965,0.0716 0,0.14315 -0.226661,0.29823 -0.226661,0.16702 -0.441391,0.16702 -0.298236,0 -0.298236,-0.44139 0,-0.51297 0.334024,-1.44347 0.334024,-0.94243 0.668052,-1.70592 0.334024,-0.77541 0.334024,-0.87085 0,-0.0238 -0.01192,-0.0238 -0.04772,0 -0.214734,0.17894 -0.751554,0.847 -1.264525,1.65821 -0.512965,0.79927 -0.691907,1.22873 -0.167014,0.42946 -0.357884,0.69191 -0.178941,0.25052 -0.429463,0.25052 -0.107366,0 -0.107366,-0.11929 0,-0.10737 0.05965,-0.23859 0.322096,-0.83507 0.620332,-1.72978 0.298241,-0.89471 0.632265,-1.99222 0.345956,-1.10944 0.560685,-1.75364 0.0358,-0.10736 0.0358,-0.21473 0,-0.0477 -0.01192,-0.0835 -0.01192,-0.0477 -0.01192,-0.0716 0,-0.0477 0.0358,-0.15508 0.274376,-0.76349 0.46525,-1.00208 0.19087,-0.25052 0.584541,-0.25052 0.155086,0 0.178946,0.10736 -1.300317,2.62449 -2.111519,5.583 1.777491,-2.77956 2.684132,-2.77956 0.250521,0 0.250521,0.16701 0,0.10736 -0.08351,0.23858 z"
              />
              <path
                id="path6208"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 73.948331,189.38654 q -0.01192,0.0119 -0.107367,0.10737 -0.09543,0.0835 -0.155082,0.13122 -0.05965,0.0477 -0.178942,0.15508 -0.107367,0.0954 -0.190874,0.15509 -0.08351,0.0596 -0.202801,0.14315 -0.119295,0.0835 -0.21473,0.13123 -0.08351,0.0358 -0.178941,0.0716 -0.09544,0.0358 -0.178942,0.0358 -0.250521,0 -0.298241,-0.29824 0,-0.50104 0.393676,-1.84907 -1.598554,2.20696 -2.290461,2.20696 -0.286309,0 -0.286309,-0.42946 0,-0.54876 0.322096,-1.47926 0.334024,-0.94243 0.811207,-1.69398 0.477178,-0.76349 0.835062,-0.76349 h 0.0358 l 0.131226,-0.0954 q 0.107363,-0.11929 0.334024,-0.11929 0.178942,0 0.501038,0.0954 0.322096,0.0954 0.357884,0.0954 0.04772,0 0.119299,-0.0954 0.0835,-0.0954 0.190869,-0.0954 0.298237,0 0.298237,0.26244 0,0.10737 -0.04772,0.2386 -0.0358,0.13122 -0.119299,0.31016 -0.07157,0.16702 -0.0835,0.2028 -0.01192,0.0238 -0.119295,0.0716 -0.09544,0.0477 -0.107367,0.0835 -0.262448,0.73964 -0.46525,1.58663 -0.202802,0.83506 -0.202802,1.02593 0,0.29824 0.167014,0.29824 0.167015,0 0.405604,-0.2028 0.250516,-0.2028 0.429458,-0.4056 0.178942,-0.2028 0.190874,-0.2028 0.02384,0 0.02384,0.0477 0,0.17895 -0.119294,0.27438 z m -0.787347,-3.17324 q -0.07158,0 -0.250521,-0.0239 -0.16701,-0.0238 -0.286309,-0.0238 -0.167009,0 -0.357883,0.0477 -0.298237,0.0835 -0.978216,1.41961 -0.67998,1.32417 -0.67998,1.98029 0,0.2028 0.119294,0.2028 0.250517,0 0.882782,-0.72769 0.644192,-0.7277 0.846994,-1.03787 0.298236,-0.47718 0.548753,-1.02594 0.250521,-0.56068 0.250521,-0.73962 0,-0.0716 -0.05965,-0.0716 z"
              />
              <path
                id="path6210"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 78.196717,185.90313 q -0.608405,1.01401 -1.133303,2.32625 -0.524897,1.31225 -0.524897,1.96836 0,0.21474 0.09544,0.21474 0.0358,0 0.226657,-0.1193 0.202801,-0.11929 0.238589,-0.11929 0.07158,0 0.07158,0.0716 0,0.14316 -0.262449,0.3221 -0.262449,0.17894 -0.524897,0.17894 -0.345956,0 -0.345956,-0.51296 0,-0.46525 0.190874,-1.08559 0.190869,-0.62033 0.596472,-1.58662 0.405603,-0.96629 0.405603,-0.97822 0.05965,-0.15508 0.05965,-0.23859 0,-0.0596 -0.0358,-0.0596 -0.05965,0 -0.262449,0.21473 -0.51297,0.57261 -1.467327,1.95643 -0.95436,1.38382 -0.97822,1.70592 -0.01192,0.0835 -0.226657,0.22666 -0.214734,0.15508 -0.357884,0.15508 -0.08351,0 -0.09544,-0.0835 0.02388,0.0358 0.441391,-1.19294 0.429463,-1.22874 0.608405,-1.7775 0.04772,-0.14315 0.04772,-0.21473 0,-0.0477 -0.02384,-0.0835 -0.01192,-0.0477 -0.01192,-0.0716 0,-0.0477 0.0358,-0.15508 0.274377,-0.76349 0.465251,-1.00208 0.190869,-0.25052 0.58454,-0.25052 0.155087,0 0.178947,0.10737 -0.978221,2.00415 -1.169091,2.86307 1.968365,-3.17324 3.01816,-3.17324 0.238589,0 0.238589,0.15508 0,0.10737 -0.08351,0.23859 z"
              />
              <path
                id="path6212"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 82.875124,182.6106 q 0.0358,0.0238 0.0358,0.10736 0,0.19087 -0.19087,0.71577 -0.178946,0.51297 -0.51297,1.34803 -0.322096,0.82314 -0.501038,1.34803 0.01192,-0.0119 0.02384,-0.0119 0.04771,0 0.09543,0.0835 0.05965,0.0835 0.05965,0.15509 0,0.0716 -0.119294,0.0716 -0.155082,0 -0.167014,-0.0358 -0.238589,0.53683 -0.608401,1.74171 -0.357888,1.20487 -0.357888,1.47925 0,0.27438 0.155087,0.27438 0.178942,0 0.417531,-0.2028 0.238589,-0.21473 0.41753,-0.42946 0.190874,-0.21473 0.226662,-0.21473 0.0358,0 0.0358,0.0596 0,0.0358 -0.02384,0.0954 -0.01192,0.0597 -0.0358,0.10737 -0.01192,0.0358 -0.02388,0.0358 -0.274376,0.27438 -0.763487,0.63226 -0.489105,0.34596 -0.763486,0.34596 -0.226657,0 -0.226657,-0.25052 0,-0.6442 0.453318,-1.96837 -0.51297,0.7277 -1.252597,1.52698 -0.7277,0.79927 -1.14523,0.79927 -0.250517,0 -0.250517,-0.35788 0,-0.51297 0.357883,-1.47926 0.357884,-0.97822 0.846994,-1.76557 0.501038,-0.79927 0.835062,-0.79927 h 0.04772 q 0.08351,0 0.190869,-0.0835 0.119295,-0.0954 0.250521,-0.0954 0.178942,0 0.501038,0.0954 0.334024,0.0954 0.357884,0.0954 0.01192,0 0.01192,-0.0119 0.858921,-2.31432 0.882781,-2.38589 -0.131227,0 -0.131227,-0.14316 0,-0.33402 0.357884,-0.87085 0.04772,-0.0954 0.190874,-0.0954 0.155082,0 0.322096,0.0835 z m -1.705916,3.68621 q 0,-0.13123 -0.703839,-0.13123 -0.202802,0 -0.298237,0.0238 -0.262449,0.0716 -1.014008,1.44347 -0.739627,1.37189 -0.739627,2.00415 0,0.19087 0.119295,0.19087 0.119294,0 0.345956,-0.19087 0.226657,-0.19087 0.41753,-0.4056 0.19087,-0.21474 0.417531,-0.46525 0.226662,-0.26245 0.238589,-0.28631 0.322097,-0.35788 0.584545,-0.83506 0.274382,-0.48911 0.441391,-0.90664 0.178942,-0.41754 0.190874,-0.44139 z"
              />
              <path
                id="path6214"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 88.289244,186.0105 q -1.443466,2.55291 -1.741702,4.11567 -0.0358,0.11929 -0.0358,0.23859 0,0.16701 0.107366,0.16701 0.04772,0 0.23859,-0.11929 0.202801,-0.10737 0.238589,-0.10737 0.05965,0 0.05965,0.0716 0,0.15508 -0.262449,0.3221 -0.262449,0.16701 -0.524893,0.16701 -0.178947,0 -0.262449,-0.1193 -0.08351,-0.10736 -0.08351,-0.38174 0,-0.27438 0.119294,-0.69191 0.119295,-0.41753 0.238589,-0.70384 0.119295,-0.29824 0.334024,-0.78734 0.226662,-0.48911 0.262449,-0.58455 0.369816,-0.87085 0.369816,-1.03786 0,-0.0835 -0.05965,-0.0835 -0.0358,0 -0.131227,0.0597 -0.620333,0.41753 -1.31224,1.34803 -0.691912,0.9305 -1.025936,2.17117 -0.02384,0.0954 -0.250521,0.22665 -0.226661,0.1193 -0.381743,0.1193 -0.143155,0 -0.143155,-0.10737 v -0.0238 l 0.01192,-0.0238 q 0.334024,-1.57469 1.12137,-3.66235 0.05965,-0.15508 0.05965,-0.21473 0,-0.0596 -0.0358,-0.0596 -0.05965,0 -0.178942,0.13122 -0.763487,0.88279 -1.348032,1.75364 -0.584545,0.87085 -0.823134,1.32417 -0.226662,0.45332 -0.453323,0.73963 -0.226661,0.28631 -0.477178,0.28631 -0.09543,0 -0.09543,-0.0954 0,-0.0835 0.04771,-0.21473 0.05965,-0.13122 0.119295,-0.26245 0.07158,-0.13122 0.08351,-0.15508 0.190874,-0.46525 0.787347,-2.32625 0.04772,-0.14316 0.04772,-0.21473 0,-0.0477 -0.02384,-0.0835 -0.01192,-0.0477 -0.01192,-0.0716 0,-0.0477 0.0358,-0.15509 0.262449,-0.75155 0.465251,-1.00208 0.202797,-0.25051 0.58454,-0.25051 0.155087,0 0.178946,0.10736 -0.97822,2.00416 -1.16909,2.86308 1.992225,-3.17324 3.01816,-3.17324 0.238589,0 0.238589,0.15508 0,0.10737 -0.08351,0.23859 -1.037868,1.75363 -1.312244,3.08973 0.584545,-1.15716 1.109443,-1.78942 0.536825,-0.64419 1.586621,-1.40767 0.226661,-0.17895 0.596472,-0.17895 0.238589,0 0.238589,0.16701 0,0.0835 -0.07157,0.22666 z"
              />
              <path
                id="path6216"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 91.632856,189.38654 q -0.01192,0.0119 -0.107367,0.10737 -0.09543,0.0835 -0.155082,0.13122 -0.05965,0.0477 -0.178942,0.15508 -0.107367,0.0954 -0.190874,0.15509 -0.08351,0.0596 -0.202801,0.14315 -0.119295,0.0835 -0.21473,0.13123 -0.08351,0.0358 -0.178942,0.0716 -0.09543,0.0358 -0.178941,0.0358 -0.250522,0 -0.298237,-0.29824 0,-0.50104 0.393671,-1.84907 -1.598548,2.20696 -2.29046,2.20696 -0.286309,0 -0.286309,-0.42946 0,-0.54876 0.322096,-1.47926 0.334029,-0.94243 0.811207,-1.69398 0.477178,-0.76349 0.835062,-0.76349 h 0.0358 l 0.131227,-0.0954 q 0.107367,-0.11929 0.334024,-0.11929 0.178942,0 0.501038,0.0954 0.322096,0.0954 0.357888,0.0954 0.04772,0 0.119295,-0.0954 0.0835,-0.0954 0.190869,-0.0954 0.298236,0 0.298236,0.26244 0,0.10737 -0.04771,0.2386 -0.0358,0.13122 -0.119294,0.31016 -0.07158,0.16702 -0.08351,0.2028 -0.01192,0.0238 -0.119295,0.0716 -0.09544,0.0477 -0.107367,0.0835 -0.262449,0.73964 -0.46525,1.58663 -0.202802,0.83506 -0.202802,1.02593 0,0.29824 0.167014,0.29824 0.167014,0 0.405604,-0.2028 0.250516,-0.2028 0.429458,-0.4056 0.178942,-0.2028 0.190874,-0.2028 0.02384,0 0.02384,0.0477 0,0.17895 -0.119294,0.27438 z m -0.787347,-3.17324 q -0.07158,0 -0.250521,-0.0239 -0.16701,-0.0238 -0.286304,-0.0238 -0.167014,0 -0.357888,0.0477 -0.298237,0.0835 -0.978217,1.41961 -0.679979,1.32417 -0.679979,1.98029 0,0.2028 0.119294,0.2028 0.250517,0 0.882782,-0.72769 0.644192,-0.7277 0.846994,-1.03787 0.298236,-0.47718 0.548757,-1.02594 0.250517,-0.56068 0.250517,-0.73962 0,-0.0716 -0.05965,-0.0716 z"
              />
              <path
                id="path6218"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 96.668588,182.6106 q 0.0358,0.0238 0.0358,0.10736 0,0.19087 -0.190874,0.71577 -0.178941,0.51297 -0.512965,1.34803 -0.322096,0.82314 -0.501038,1.34803 0.01192,-0.0119 0.02384,-0.0119 0.04772,0 0.09544,0.0835 0.05965,0.0835 0.05965,0.15509 0,0.0716 -0.119294,0.0716 -0.155082,0 -0.167015,-0.0358 -0.238589,0.53683 -0.6084,1.74171 -0.357888,1.20487 -0.357888,1.47925 0,0.27438 0.155086,0.27438 0.178942,0 0.417531,-0.2028 0.238589,-0.21473 0.417531,-0.42946 0.190874,-0.21473 0.226662,-0.21473 0.0358,0 0.0358,0.0596 0,0.0358 -0.02384,0.0954 -0.01192,0.0597 -0.0358,0.10737 -0.01192,0.0358 -0.02388,0.0358 -0.274376,0.27438 -0.763487,0.63226 -0.489106,0.34596 -0.763487,0.34596 -0.226661,0 -0.226661,-0.25052 0,-0.6442 0.453323,-1.96837 -0.51297,0.7277 -1.252597,1.52698 -0.7277,0.79927 -1.145231,0.79927 -0.250516,0 -0.250516,-0.35788 0,-0.51297 0.357883,-1.47926 0.357884,-0.97822 0.846994,-1.76557 0.501038,-0.79927 0.835062,-0.79927 h 0.04772 q 0.08351,0 0.190869,-0.0835 0.119295,-0.0954 0.250521,-0.0954 0.178942,0 0.501038,0.0954 0.334024,0.0954 0.357884,0.0954 0.01192,0 0.01192,-0.0119 0.858927,-2.31432 0.882786,-2.38589 -0.131226,0 -0.131226,-0.14316 0,-0.33402 0.357883,-0.87085 0.04772,-0.0954 0.190874,-0.0954 0.155082,0 0.322096,0.0835 z m -1.705915,3.68621 q 0,-0.13123 -0.70384,-0.13123 -0.202801,0 -0.298236,0.0238 -0.262449,0.0716 -1.014008,1.44347 -0.739627,1.37189 -0.739627,2.00415 0,0.19087 0.119294,0.19087 0.119295,0 0.345956,-0.19087 0.226657,-0.19087 0.417531,-0.4056 0.19087,-0.21474 0.417531,-0.46525 0.226662,-0.26245 0.238589,-0.28631 0.322096,-0.35788 0.584545,-0.83506 0.274377,-0.48911 0.441391,-0.90664 0.178942,-0.41754 0.190874,-0.44139 z"
              />
              <path
                id="path6220"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 98.778241,186.63083 q 0.07158,0.36982 0.07158,0.59647 0,0.26245 -0.178942,0.45333 -0.178942,0.17894 -0.46525,0.26245 -0.286309,0.0716 -0.51297,0.10736 -0.226657,0.0238 -0.429459,0.0238 -0.119294,0 -0.274381,0 -0.143154,-0.0119 -0.155082,-0.0119 -0.393671,1.00207 -0.393671,1.57469 0,0.47718 0.357884,0.47718 0.250516,0 0.584545,-0.31017 0.334023,-0.3221 0.584545,-0.63226 0.250516,-0.3221 0.298236,-0.3221 0.08351,0 0.08351,0.0954 0,0.33402 -0.656124,0.9305 -0.65612,0.58454 -1.025936,0.58454 -0.298236,0 -0.548753,-0.17894 -0.238589,-0.19087 -0.238589,-0.62033 0,-0.13123 0.0358,-0.31017 0.08351,-0.45332 0.214729,-0.88278 0.143154,-0.42946 0.155082,-0.5249 -0.178942,-0.0477 -0.178942,-0.19087 0,-0.13122 0.202802,-0.13122 h 0.08351 q 0.477178,-0.94243 0.548757,-1.08559 0.334024,-0.63226 1.276453,-0.63226 0.405603,0 0.560685,0.7277 z m -0.429459,0.57261 q 0,-0.29823 -0.05965,-0.51296 -0.05965,-0.21473 -0.143155,-0.29824 -0.07158,-0.0835 -0.155082,-0.0835 -0.238593,0 -0.572617,0.51296 -0.322096,0.51297 -0.477178,0.90664 0.02384,0 0.190869,0.0119 0.167015,0.0119 0.286309,0.0119 0.48911,0 0.70384,-0.10736 0.214729,-0.10737 0.226661,-0.4414 z"
              />
              <path
                id="path6222"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 101.51159,190.20968 q -0.0597,0.14315 -0.1193,0.14315 -0.10737,0 -0.23859,-0.14315 -0.13123,-0.14316 -0.13123,-0.33403 0,-0.17894 0.28631,-0.90664 0.0358,-0.0954 0.10737,-0.14315 0.0835,-0.0477 0.0954,-0.0835 1.28838,-3.35218 2.03993,-5.92895 l 0.0954,-0.0716 q 0.0835,-0.0716 0.2028,-0.14315 0.13123,-0.0716 0.21473,-0.0716 0.1193,0 0.1193,0.17894 -0.13123,0.48911 -0.83507,2.39783 -0.70384,1.90872 -1.15716,3.00623 0.45332,-0.67998 1.19295,-1.51505 0.75156,-0.84699 1.12138,-0.84699 0.23858,0 0.23858,0.44139 v 0.0835 q -0.0119,0.23859 -0.22666,1.07365 0.26245,-0.13122 0.35789,-0.13122 0.0358,0 0.0358,0.0239 0,0.0597 -0.15509,0.17894 -0.14315,0.1193 -0.29824,0.17894 -0.46525,1.5389 -0.90664,2.02801 -0.16701,0.17895 -0.67998,0.50104 -0.51296,0.31017 -0.63226,0.31017 -0.48911,0 -0.7277,-0.22666 z m 2.3501,-2.32625 q -1.40768,0.73963 -1.81328,1.18102 -0.0716,0.14315 -0.17894,0.36981 -0.0954,0.22666 -0.13122,0.29824 0.2863,0.3221 0.58454,0.3221 0.48911,0 0.90664,-0.7277 0.42946,-0.7277 0.63226,-1.44347 z m 0.0954,-0.26245 q 0.19087,-0.50104 0.21473,-1.03787 0,-0.25051 -0.1193,-0.25051 -0.39367,0 -1.92064,2.43361 0.71576,-0.58454 1.82521,-1.14523 z"
              />
              <path
                id="path6224"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 108.88363,185.71226 q 0.0358,0.0597 0.0358,0.13123 0,0.47717 -1.04979,1.92064 -1.03787,1.44347 -1.67013,2.1831 v -0.0239 q -0.0119,0 -0.0358,0.0954 -0.0119,0.0954 -0.0477,0.23859 -0.0358,0.14315 -0.0716,0.27438 -0.0358,0.14316 -0.0954,0.23859 -0.0477,0.10737 -0.0954,0.10737 -0.0477,0 -0.13123,-0.0358 -0.0716,-0.0238 -0.0835,-0.0238 -1.61047,2.15923 -1.61047,2.76764 0,0.10736 0.0477,0.21473 0.0477,0.11929 0.0477,0.15508 0,0.13123 -0.14315,0.22666 -0.14316,0.0954 -0.28631,0.0954 -0.19087,0 -0.19087,-0.22665 0,-0.42947 0.51297,-1.31225 0.51297,-0.87085 1.04979,-1.62241 0.54876,-0.75155 0.56069,-0.79927 0.13122,-0.39368 0.13122,-1.07365 0,-0.97822 -0.19087,-1.71785 -0.17894,-0.73963 -0.50104,-0.73963 -0.0358,0 -0.0954,0 l -0.0716,0.0119 q -0.0477,0 -0.0477,-0.0597 0,-0.0954 0.26245,-0.28631 0.0358,-0.0239 0.2028,-0.26245 0.16701,-0.23858 0.25052,-0.23858 0.25052,0 0.44139,0.77541 0.2028,0.76349 0.2028,1.70592 0,0.0954 -0.0119,0.2863 0,0.19088 0,0.28631 0,0.19087 0.0954,0.19087 0.27437,0 1.09751,-1.26452 0.83506,-1.26453 0.83506,-1.61048 0,-0.0716 -0.0596,-0.0716 -0.0239,0 -0.0835,0.0238 -0.0597,0.0238 -0.0954,0.0238 -0.0597,0 -0.0954,-0.0597 0,-0.15509 0.34595,-0.34596 0.34596,-0.19087 0.56069,-0.19087 0.0597,0 0.0835,0.0119 z"
              />
              <path
                id="path6226"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 121.32161,184.56703 q 0.0477,0 0.10736,0.0477 0.0716,0.0477 0.1193,0.14315 0.0596,0.0835 0.0596,0.17894 0,0.25053 -0.10737,0.63227 -0.85892,2.875 -0.85892,4.07988 0,0.9305 0.4891,0.9305 0.42947,0 1.10945,-0.59647 0.67998,-0.59648 1.32417,-1.49119 0.64419,-0.90664 1.09751,-2.09959 0.46525,-1.19295 0.46525,-2.25467 0,-1.12137 -0.62033,-1.34803 -0.17895,-0.0596 -0.17895,-0.15508 0,-0.0238 0.0239,-0.0477 0.0238,-0.0358 0.0596,-0.0477 0.0477,-0.0119 0.10737,-0.0119 0.48911,0 0.82314,0.40561 0.34595,0.39367 0.34595,1.14523 0,1.06172 -0.54876,2.3501 -0.54875,1.27646 -1.31224,2.29046 -0.76349,1.00208 -1.59855,1.68206 -0.82313,0.69191 -1.37189,0.69191 -0.73963,0 -0.73963,-1.3361 0,-0.45332 0.0835,-1.07365 0.0954,-0.63227 0.19087,-1.09752 0.0954,-0.47718 0.23859,-1.09751 0.14315,-0.63226 0.17894,-0.82313 -0.88278,0.70384 -1.861,1.92064 -0.97821,1.21681 -1.47925,1.99223 -0.48911,0.77541 -0.87086,1.44346 v -0.0119 q -0.27437,0.51297 -0.53682,0.51297 -0.1193,0 -0.19088,-0.10736 -0.0596,-0.0954 -0.0596,-0.27438 0,-0.15509 0.0477,-0.3221 0.0358,-0.11929 0.56068,-1.69398 0.5249,-1.5747 0.88278,-3.03009 0.36982,-1.4554 0.36982,-2.37397 0,-0.67998 -0.31017,-0.96629 -0.29824,-0.29823 -1.01401,-0.29823 -0.45332,0 -1.07365,0.14315 -0.62033,0.14316 -1.31224,0.45332 -0.67998,0.31017 -1.26453,0.7277 -0.57261,0.4056 -0.95435,1.014 -0.38175,0.59648 -0.38175,1.26453 0,0.71577 0.57262,1.20488 0.58454,0.4891 1.32417,0.4891 0.65612,0 0.94243,-0.2028 0.0239,-0.0238 0.0477,-0.0358 0.0358,-0.0119 0.0596,-0.0119 0.0239,-0.0119 0.0477,-0.0119 0.0716,0 0.0716,0.0596 0,0.0835 -0.16702,0.17894 -0.34595,0.20281 -1.07365,0.20281 -0.10736,0 -0.25052,0 -0.79927,-0.0238 -1.43153,-0.56069 -0.62034,-0.53682 -0.62034,-1.34803 0,-0.79928 0.54876,-1.5389 0.56068,-0.75156 1.38382,-1.22874 0.83506,-0.48911 1.76556,-0.77541 0.94243,-0.29825 1.74171,-0.29825 2.03994,0 2.03994,1.80136 0,0.36981 -0.0716,0.77541 -0.0596,0.40561 -0.23859,0.96629 -0.16701,0.54876 -0.25052,0.79928 -0.0835,0.23859 -0.35788,0.95436 -0.26245,0.71576 -0.29824,0.79927 -0.39367,1.09751 -0.46525,1.70592 2.51712,-3.17324 3.67428,-4.47356 0.0954,-0.10736 0.23859,-0.27438 0.35788,-0.4056 0.48911,-0.53682 0.14315,-0.13123 0.23859,-0.13123 z"
              />
              <path
                id="path6228"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 127.73762,183.77969 q 0,0.15508 -0.22666,0.39367 -0.22666,0.23859 -0.28631,0.36981 -0.15508,0.39367 -0.33402,0.44139 -0.2386,0 -0.2386,-0.39367 0,-0.25052 0.36982,-0.54875 0.36981,-0.29824 0.64419,-0.29824 0.0597,0 0.0716,0.0358 z m -0.67998,2.03994 q -0.0238,0.0358 -0.16701,0.29823 -0.13123,0.26245 -0.22667,0.45332 -0.0954,0.19087 -0.26244,0.56069 -0.16702,0.36982 -0.29824,0.70384 -0.13123,0.33402 -0.27438,0.79927 -0.14315,0.46525 -0.25052,0.9305 -0.0119,0.0358 -0.0119,0.0954 0,0.14315 0.1193,0.14315 0.0716,0 0.38175,-0.17894 0.32209,-0.17894 0.41753,-0.17894 0.0835,0 0.0954,0.0477 0,0.14315 -0.6084,0.53683 -0.6084,0.38174 -0.83507,0.38174 -0.22666,0 -0.22666,-0.21474 0,-0.10736 0.0477,-0.25051 0.13122,-0.36982 0.26245,-0.76349 0.14316,-0.39367 0.21473,-0.6084 0.0716,-0.21473 0.14315,-0.44139 0.0835,-0.22667 0.1193,-0.33403 0.0358,-0.11929 0.0597,-0.22666 0.0358,-0.11929 0.0477,-0.17894 0.0119,-0.0597 0.0119,-0.1193 0,-0.0477 -0.0238,-0.0835 -0.0119,-0.0477 -0.0119,-0.0716 0,-0.0477 0.0358,-0.15508 0.26245,-0.75156 0.46525,-1.00208 0.2028,-0.25052 0.59647,-0.25052 0.15508,0 0.17894,0.10737 z"
              />
              <path
                id="path6230"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 129.90841,182.90883 q -0.65612,1.35997 -1.3361,3.29254 -0.67998,1.92065 -1.00208,3.36411 -0.0119,0.0358 -0.0119,0.0954 0,0.14315 0.1193,0.14315 0.0716,0 0.38174,-0.17894 0.3221,-0.17894 0.4056,-0.17894 0.0716,0 0.10737,0.0477 0,0.14315 -0.59648,0.53683 -0.59647,0.38174 -0.84699,0.38174 -0.22666,0 -0.22666,-0.21474 0,-0.11929 0.0477,-0.25051 0.31016,-0.847 0.57261,-1.68206 0.27438,-0.83506 0.62034,-1.98029 0.34595,-1.15716 0.51296,-1.70592 0.0358,-0.10737 0.0358,-0.21473 0,-0.0477 -0.0238,-0.0835 -0.0119,-0.0477 -0.0119,-0.0835 0,-0.0358 0.0358,-0.14316 0.23859,-0.75155 0.44139,-1.00207 0.2028,-0.25052 0.59648,-0.25052 0.16701,0 0.17894,0.10736 z"
              />
              <path
                id="path6232"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 132.05199,182.90883 q -0.65612,1.35997 -1.3361,3.29254 -0.67998,1.92065 -1.00208,3.36411 -0.0119,0.0358 -0.0119,0.0954 0,0.14315 0.1193,0.14315 0.0716,0 0.38174,-0.17894 0.3221,-0.17894 0.4056,-0.17894 0.0716,0 0.10737,0.0477 0,0.14315 -0.59647,0.53683 -0.59648,0.38174 -0.847,0.38174 -0.22666,0 -0.22666,-0.21474 0,-0.11929 0.0477,-0.25051 0.31016,-0.847 0.57261,-1.68206 0.27438,-0.83506 0.62034,-1.98029 0.34595,-1.15716 0.51297,-1.70592 0.0358,-0.10737 0.0358,-0.21473 0,-0.0477 -0.0238,-0.0835 -0.0119,-0.0477 -0.0119,-0.0835 0,-0.0358 0.0358,-0.14316 0.23859,-0.75155 0.44139,-1.00207 0.2028,-0.25052 0.59648,-0.25052 0.16701,0 0.17894,0.10736 z"
              />
              <path
                id="path6234"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 140.62817,189.48198 q 0,0.0716 -0.19087,0.19087 -0.96629,0.46525 -1.71785,1.43154 -0.0477,0.0716 -0.10736,0.0716 -0.1193,0 -0.1193,-0.16702 0,-0.13122 0.17894,-0.36981 0.19087,-0.23859 0.33403,-0.34596 0.0238,-0.34595 0.0477,-0.91857 0.0358,-0.57261 0.0477,-1.15716 0.0238,-0.58454 0.0238,-0.91857 0,-0.14315 0,-0.21473 -3.65042,0.0358 -3.67428,0.0358 -0.54876,0.84699 -0.847,1.35996 -0.2863,0.51297 -0.54875,1.32417 -0.26245,0.79928 -0.26245,1.58662 0,0.62034 0.2863,0.9305 0.10737,0.10737 0.10737,0.16701 0,0.0716 -0.21473,0.0716 -0.32209,0 -0.47718,-0.46525 -0.14315,-0.45331 -0.14315,-0.85892 0,-1.00207 0.45332,-1.99222 0.46525,-1.00208 1.24066,-2.12345 -0.0477,0 -0.11929,0 -0.0597,0 -0.1193,0 -0.0596,0 -0.14315,0 -0.0716,0 -0.14315,0.0119 -0.0597,0 -0.13123,0 -0.0716,0 -0.14315,0 -0.26245,0 -0.41753,-0.0119 -0.15509,-0.0119 -0.15509,-0.0477 0,-0.10737 0.0954,-0.17894 0.0954,-0.0716 0.26245,-0.0954 0.17894,-0.0358 0.34595,-0.0477 0.17895,-0.0239 0.38175,-0.0239 0.13122,0 0.26245,0.0119 0.13122,0 0.21473,0.0119 0.0954,0 0.0954,0 1.30031,-1.75363 3.17324,-3.55498 -0.11929,-0.51297 -0.11929,-0.65612 0,-0.2386 0.28631,-0.2386 0.35788,0 0.41753,0.34596 0.21473,-0.21473 0.28631,-0.21473 0.11929,0 0.11929,0.22666 0,0.0358 -0.0119,0.0954 0,0.0477 0,0.0716 -0.0358,0.0358 -0.13122,0.11929 -0.0954,0.0835 -0.14316,0.14316 0.3221,1.49118 0.3221,3.66235 0.0119,0 0.0358,0 0.0358,0 0.0477,0 0.91857,0 1.00207,0.16701 -0.0238,0.0597 -0.45331,0.10737 -0.41754,0.0358 -0.63227,0.0358 v 2.77956 q 0.82314,-0.44139 0.99015,-0.44139 0.10737,0 0.10737,0.0835 z m -1.50312,-2.71993 q 0,-0.51296 -0.15508,-1.57468 -0.15508,-1.07366 -0.34595,-1.56277 -2.13538,1.95644 -2.9108,3.13745 z"
              />
              <path
                id="path6236"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 145.7612,182.6106 q 0.0358,0.0238 0.0358,0.10736 0,0.19087 -0.19087,0.71577 -0.17894,0.51297 -0.51297,1.34803 -0.32209,0.82314 -0.50104,1.34803 0.0119,-0.0119 0.0239,-0.0119 0.0477,0 0.0954,0.0835 0.0596,0.0835 0.0596,0.15509 0,0.0716 -0.1193,0.0716 -0.15508,0 -0.16701,-0.0358 -0.23859,0.53683 -0.6084,1.74171 -0.35788,1.20487 -0.35788,1.47925 0,0.27438 0.15508,0.27438 0.17894,0 0.41753,-0.2028 0.23859,-0.21473 0.41753,-0.42946 0.19087,-0.21473 0.22666,-0.21473 0.0358,0 0.0358,0.0596 0,0.0358 -0.0239,0.0954 -0.0119,0.0597 -0.0358,0.10737 -0.0119,0.0358 -0.0238,0.0358 -0.27437,0.27438 -0.76349,0.63226 -0.4891,0.34596 -0.76348,0.34596 -0.22666,0 -0.22666,-0.25052 0,-0.6442 0.45332,-1.96837 -0.51297,0.7277 -1.25259,1.52698 -0.7277,0.79927 -1.14524,0.79927 -0.25051,0 -0.25051,-0.35788 0,-0.51297 0.35788,-1.47926 0.35788,-0.97822 0.84699,-1.76557 0.50104,-0.79927 0.83506,-0.79927 h 0.0477 q 0.0835,0 0.19088,-0.0835 0.11929,-0.0954 0.25051,-0.0954 0.17895,0 0.50104,0.0954 0.33403,0.0954 0.35789,0.0954 0.0119,0 0.0119,-0.0119 0.85892,-2.31432 0.88278,-2.38589 -0.13123,0 -0.13123,-0.14316 0,-0.33402 0.35789,-0.87085 0.0477,-0.0954 0.19087,-0.0954 0.15508,0 0.32209,0.0835 z m -1.70591,3.68621 q 0,-0.13123 -0.70384,-0.13123 -0.20281,0 -0.29824,0.0238 -0.26245,0.0716 -1.01401,1.44347 -0.73963,1.37189 -0.73963,2.00415 0,0.19087 0.1193,0.19087 0.11929,0 0.34595,-0.19087 0.22667,-0.19087 0.41754,-0.4056 0.19087,-0.21474 0.41753,-0.46525 0.22666,-0.26245 0.23859,-0.28631 0.32209,-0.35788 0.58454,-0.83506 0.27438,-0.48911 0.44139,-0.90664 0.17895,-0.41754 0.19088,-0.44139 z"
              />
              <path
                id="path6238"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 148.69399,189.38654 q -0.0119,0.0119 -0.10737,0.10737 -0.0954,0.0835 -0.15508,0.13122 -0.0596,0.0477 -0.17894,0.15508 -0.10737,0.0954 -0.19087,0.15509 -0.0835,0.0596 -0.2028,0.14315 -0.1193,0.0835 -0.21473,0.13123 -0.0835,0.0358 -0.17895,0.0716 -0.0954,0.0358 -0.17894,0.0358 -0.25052,0 -0.29823,-0.29824 0,-0.50104 0.39367,-1.84907 -1.59856,2.20696 -2.29046,2.20696 -0.28631,0 -0.28631,-0.42946 0,-0.54876 0.32209,-1.47926 0.33403,-0.94243 0.81121,-1.69398 0.47718,-0.76349 0.83506,-0.76349 h 0.0358 l 0.13123,-0.0954 q 0.10737,-0.11929 0.33402,-0.11929 0.17895,0 0.50104,0.0954 0.3221,0.0954 0.35789,0.0954 0.0477,0 0.11929,-0.0954 0.0835,-0.0954 0.19087,-0.0954 0.29824,0 0.29824,0.26244 0,0.10737 -0.0477,0.2386 -0.0358,0.13122 -0.1193,0.31016 -0.0716,0.16702 -0.0835,0.2028 -0.0119,0.0238 -0.11929,0.0716 -0.0954,0.0477 -0.10737,0.0835 -0.26245,0.73964 -0.46525,1.58663 -0.2028,0.83506 -0.2028,1.02593 0,0.29824 0.16701,0.29824 0.16702,0 0.40561,-0.2028 0.25051,-0.2028 0.42946,-0.4056 0.17894,-0.2028 0.19087,-0.2028 0.0238,0 0.0238,0.0477 0,0.17895 -0.1193,0.27438 z m -0.78734,-3.17324 q -0.0716,0 -0.25053,-0.0239 -0.16701,-0.0238 -0.2863,-0.0238 -0.16701,0 -0.35789,0.0477 -0.29823,0.0835 -0.97821,1.41961 -0.67998,1.32417 -0.67998,1.98029 0,0.2028 0.11929,0.2028 0.25052,0 0.88278,-0.72769 0.64419,-0.7277 0.847,-1.03787 0.29823,-0.47718 0.54875,-1.02594 0.25052,-0.56068 0.25052,-0.73962 0,-0.0716 -0.0597,-0.0716 z"
              />
              <path
                id="path6240"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 155.08969,186.0105 q -1.44347,2.55291 -1.74171,4.11567 -0.0358,0.11929 -0.0358,0.23859 0,0.16701 0.10737,0.16701 0.0477,0 0.23859,-0.11929 0.2028,-0.10737 0.23859,-0.10737 0.0596,0 0.0596,0.0716 0,0.15508 -0.26245,0.3221 -0.26245,0.16701 -0.52489,0.16701 -0.17895,0 -0.26245,-0.1193 -0.0835,-0.10736 -0.0835,-0.38174 0,-0.27438 0.1193,-0.69191 0.11929,-0.41753 0.23859,-0.70384 0.11929,-0.29824 0.33402,-0.78734 0.22666,-0.48911 0.26245,-0.58455 0.36982,-0.87085 0.36982,-1.03786 0,-0.0835 -0.0597,-0.0835 -0.0358,0 -0.13123,0.0597 -0.62033,0.41753 -1.31224,1.34803 -0.69191,0.9305 -1.02593,2.17117 -0.0238,0.0954 -0.25052,0.22665 -0.22667,0.1193 -0.38175,0.1193 -0.14315,0 -0.14315,-0.10737 v -0.0238 l 0.0119,-0.0238 q 0.33402,-1.57469 1.12137,-3.66235 0.0596,-0.15508 0.0596,-0.21473 0,-0.0596 -0.0358,-0.0596 -0.0596,0 -0.17894,0.13122 -0.76349,0.88279 -1.34803,1.75364 -0.58455,0.87085 -0.82313,1.32417 -0.22667,0.45332 -0.45333,0.73963 -0.22666,0.28631 -0.47718,0.28631 -0.0954,0 -0.0954,-0.0954 0,-0.0835 0.0477,-0.21473 0.0597,-0.13122 0.1193,-0.26245 0.0716,-0.13122 0.0835,-0.15508 0.19087,-0.46525 0.78734,-2.32625 0.0477,-0.14316 0.0477,-0.21473 0,-0.0477 -0.0238,-0.0835 -0.0119,-0.0477 -0.0119,-0.0716 0,-0.0477 0.0358,-0.15509 0.26244,-0.75155 0.46524,-1.00208 0.20281,-0.25051 0.58455,-0.25051 0.15509,0 0.17894,0.10736 -0.97822,2.00416 -1.16909,2.86308 1.99222,-3.17324 3.01816,-3.17324 0.23859,0 0.23859,0.15508 0,0.10737 -0.0835,0.23859 -1.03787,1.75363 -1.31225,3.08973 0.58455,-1.15716 1.10945,-1.78942 0.53682,-0.64419 1.58662,-1.40767 0.22666,-0.17895 0.59647,-0.17895 0.23859,0 0.23859,0.16701 0,0.0835 -0.0716,0.22666 z"
              />
              <path
                id="path6242"
                style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '26.52406311px',
                  lineHeight: '125%',
                  fontFamily: "'Bilbo Swash Caps'",
                  InkscapeFontSpecification: "'Bilbo Swash Caps, Normal'",
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  writingMode: 'lr-tb',
                  textAnchor: 'start',
                  display: 'inline',
                  fill: '#333333',
                  fillOpacity: '1',
                  stroke: '#333333',
                  strokeWidth: '0.33766484',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                d="m 157.89647,186.24909 q -0.0238,0.23859 -0.31016,0.67998 -0.28631,0.44139 -0.44139,0.44139 -0.0477,0 -0.0477,-0.0716 0,-0.10736 0.13122,-0.42946 0.13122,-0.33402 0.13122,-0.42946 0,-0.17894 -0.21472,-0.17894 -0.0358,0 -0.39368,0.0596 -0.29824,0.0716 -0.78735,0.38175 -0.47718,0.31017 -0.47718,0.67998 0,0.13122 0.0597,0.23859 0.15508,0.31016 0.53683,0.5249 0.39367,0.21473 0.66805,0.4056 0.28631,0.19087 0.28631,0.50103 0,0.5249 -0.81121,1.01401 -0.79927,0.47718 -1.37189,0.47718 -0.0954,0 -0.15508,-0.0835 -0.0596,-0.0716 -0.0596,-0.15508 0,-0.14315 0.13123,-0.14315 0.39367,0 1.09751,-0.23859 0.71577,-0.25052 0.71577,-0.53683 0,-0.16701 -0.27438,-0.39367 -0.26245,-0.22666 -0.58455,-0.41753 -0.31016,-0.19087 -0.58454,-0.45332 -0.26245,-0.27438 -0.26245,-0.5249 0,-0.2028 0.14315,-0.38174 0.10737,-0.13123 0.22667,-0.25052 0.11929,-0.13123 0.22666,-0.22666 0.10736,-0.0954 0.23859,-0.19088 0.14315,-0.0954 0.25051,-0.16701 0.10737,-0.0716 0.25052,-0.14315 0.14316,-0.0716 0.22667,-0.10737 0.0835,-0.0477 0.21472,-0.10736 0.14316,-0.0597 0.19087,-0.0716 0.0597,-0.0239 0.17895,-0.0716 0.1193,-0.0477 0.13122,-0.0477 0.2028,-0.0597 0.31017,-0.0597 0.42946,0 0.42946,0.47718 z"
              />
              <g
                id="g4266"
                style={{
                  display: 'inline',
                  stroke: '#333333',
                  strokeWidth: '20.45614433',
                  strokeMiterlimit: '4',
                  strokeDasharray: 'none',
                  strokeOpacity: '1',
                }}
                transform="matrix(0.06223052,0,0,0.06223052,-14.791286,146.34822)"
              >
                <path
                  id="circle4268"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '22.03065491',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 1130.5778,345.43222 a 160.0455,160.0455 0 0 1 -160.04551,160.0455 160.0455,160.0455 0 0 1 -160.0455,-160.0455 160.0455,160.0455 0 0 1 160.0455,-160.0455 160.0455,160.0455 0 0 1 160.04551,160.0455 z"
                  transform="matrix(0.92853096,0,0,0.92853096,61.155559,174.47386)"
                />
                <path
                  id="circle4270"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '22.03065491',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 1130.5778,345.43222 a 160.0455,160.0455 0 0 1 -160.04551,160.0455 160.0455,160.0455 0 0 1 -160.0455,-160.0455 160.0455,160.0455 0 0 1 160.0455,-160.0455 160.0455,160.0455 0 0 1 160.04551,160.0455 z"
                  transform="matrix(0.92853096,0,0,0.92853096,61.155569,25.866663)"
                />
                <path
                  id="circle4272"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '22.03065491',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 1130.5778,345.43222 a 160.0455,160.0455 0 0 1 -160.04551,160.0455 160.0455,160.0455 0 0 1 -160.0455,-160.0455 160.0455,160.0455 0 0 1 160.0455,-160.0455 160.0455,160.0455 0 0 1 160.04551,160.0455 z"
                  transform="matrix(0.92853096,0,0,0.92853096,61.155569,323.08107)"
                />
                <path
                  id="circle4274"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '22.03065491',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 1130.5778,345.43222 a 160.0455,160.0455 0 0 1 -160.04551,160.0455 160.0455,160.0455 0 0 1 -160.0455,-160.0455 160.0455,160.0455 0 0 1 160.0455,-160.0455 160.0455,160.0455 0 0 1 160.04551,160.0455 z"
                  transform="matrix(0.92853096,0,0,0.92853096,-67.570641,100.17026)"
                />
                <path
                  id="circle4276"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '22.03065491',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 1130.5778,345.43222 a 160.0455,160.0455 0 0 1 -160.04551,160.0455 160.0455,160.0455 0 0 1 -160.0455,-160.0455 160.0455,160.0455 0 0 1 160.0455,-160.0455 160.0455,160.0455 0 0 1 160.04551,160.0455 z"
                  transform="matrix(0.92853096,0,0,0.92853096,189.88177,100.17027)"
                />
                <path
                  id="circle4278"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '22.03065491',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 1130.5778,345.43222 a 160.0455,160.0455 0 0 1 -160.04551,160.0455 160.0455,160.0455 0 0 1 -160.0455,-160.0455 160.0455,160.0455 0 0 1 160.0455,-160.0455 160.0455,160.0455 0 0 1 160.04551,160.0455 z"
                  transform="matrix(0.92853096,0,0,0.92853096,-67.569911,248.77746)"
                />
                <path
                  id="circle4280"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '22.03065491',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="m 1130.5778,345.43222 a 160.0455,160.0455 0 0 1 -160.04551,160.0455 160.0455,160.0455 0 0 1 -160.0455,-160.0455 160.0455,160.0455 0 0 1 160.0455,-160.0455 160.0455,160.0455 0 0 1 160.04551,160.0455 z"
                  transform="matrix(0.92853096,0,0,0.92853096,189.88177,248.77748)"
                />
                <path
                  id="circle4282"
                  style={{
                    fill: 'none',
                    stroke: '#333333',
                    strokeWidth: '16.56585121',
                    strokeMiterlimit: '4',
                    strokeDasharray: 'none',
                    strokeOpacity: '1',
                  }}
                  d="M 736.61964,446.99954 A 243.14604,243.14604 0 0 1 493.4736,690.14558 243.14604,243.14604 0 0 1 250.32756,446.99954 243.14604,243.14604 0 0 1 493.4736,203.8535 243.14604,243.14604 0 0 1 736.61964,446.99954 Z"
                  transform="matrix(1.2348381,0,0,1.2348381,352.96344,-56.753688)"
                />
              </g>
            </g>
          </g>
        </animated.svg>
      </Link>
    </LogoContainer>
  )
}

export default Logo
